// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconTaxPath = 'M5.129 3h13.83l5.912 4.72V27H5.13V3Zm2.4 2.4v19.2h14.942V11.235h-5.828V5.4H7.529Zm11.514.739v2.696h3.378L19.043 6.14Zm.502 7.99-7.216 8.832-1.859-1.518 7.216-8.833 1.859 1.519Zm-9.338.81a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0Zm8.001 4.03a1.6 1.6 0 1 0 0 3.201 1.6 1.6 0 0 0 0-3.2Z';
var NavigationIconTax = baseIcon('NavigationIconTax', {
  getPath: () => NavigationIconTaxPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconTax;
//# sourceMappingURL=index.js.map